<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">{{ translations.errorHeading }}</h3>
      <p class="info-text">{{ translations.errorInfo }}</p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner [infoText]="translations.loading"></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <div>
        <ng-container
          *ngFor="let loanOption of presentedLoanOptions; let i = index"
        >
          <app-installments-item
            [isFirstItem]="i === 0"
            [isLastItem]="
              i === availableLoanOptions.length - 1 &&
              equalOrLessThanThreeLoanOptions
            "
            [title]="loanOption.title"
            [selected]="loanOption === selectedLoanOption"
            (click)="
              loanOption !== selectedLoanOption && selectInstallment(loanOption)
            "
            [bulletPoints]="loanOption.bulletPoints"
            [link]="loanOption.link"
            [radioButtonColor]="loanOption.radioButtonColor"
            [color]="loanOption.color"
            [badgeText]="loanOption.badgeText"
          ></app-installments-item>
        </ng-container>
        <button
          *ngIf="!equalOrLessThanThreeLoanOptions"
          class="installments-button"
          (click)="expanded ? viewReducedLoanOptions() : viewAllLoanOptions()"
        >
          {{ expanded ? translations.showLess : translations.showMore }}
          <img
            class="expand-button"
            [src]="
              expanded
                ? 'assets/icon/Arrow-Up.svg'
                : 'assets/icon/Arrow-Down.svg'
            "
          />
        </button>
      </div>
      <div class="bottom-secetion-wrapper">
        <div class="pr-info">
          <label>{{ translations.amount }}</label>
          <label>
            {{ state.totalCheckoutValue | value }}
          </label>
        </div>

        <div class="button-container">
          <zaver-primary-button
            [text]="translations.nextButton"
            [disabled]="navigationInProgress || !selectedLoanOption"
            [loading]="navigationInProgress"
            (click)="handleCtaClick()"
          ></zaver-primary-button>
        </div>

        <p *ngIf="currentLoanTermsStr" class="loan-terms-string">
          {{ translations.calculations }} {{ currentLoanTermsStr }}
        </p>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="translations.closeButton"
  [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
  (onClose)="toggleModal()"
>
  <app-selector
    #selector
    [selectorItems]="selectorItems"
    [selectedItem]="selectorItems[1]"
  ></app-selector>
</zaver-checkout-modal>
